module.exports = __webpack_public_path__ + "static/img/iEP-1.c9f2faa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/iEP-1.jpg
// module id = yzlU
// module chunks = 1